export const ALLOWED_CITY_NAMES = ['AI', 'Ep', 'Oz', 'O K', 'Ti', 'Y'];
